import { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext/AuthContext';
import './FreePlanInfoCard.css';

/**
 * Card informativo exibido para usuários no plano FREE.
 * Informa que têm até 1 ano de uso gratuito a partir do cadastro.
 * Não substitui o FreePlanBanner (avisos de urgência quando falta pouco tempo).
 */
export default function FreePlanInfoCard() {
  const { user } = useContext(AuthContext);

  if (!user?.is_free_plan || user?.is_free_expired) {
    return null;
  }

  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return new Date(isoDate).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const daysRemaining = user.free_days_remaining ?? 0;
  const expirationDate = user.free_expiration_date;

  return (
    <div className="free-plan-info-card">
      <div className="free-plan-info-card-content">
        <div className="free-plan-info-card-header">
          <svg
            className="free-plan-info-card-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h3 className="free-plan-info-card-title">Plano FREE ativo</h3>
        </div>
        <div className="free-plan-info-card-description">
          <p>
            Você tem até <strong>1 ano de uso gratuito</strong> a partir do
            cadastro.
          </p>
          {expirationDate && (
            <p>
              Seu acesso gratuito é válido até{' '}
              <strong>{formatDate(expirationDate)}</strong>
              {daysRemaining > 0 && (
                <> ({daysRemaining} {daysRemaining === 1 ? 'dia restante' : 'dias restantes'})</>
              )}
              .
            </p>
          )}
          <p className="free-plan-info-card-cta">
            <Link to="/planos" className="free-plan-info-card-link">
              Conheça os planos pagos →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
